import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mobileFilterTypes", "itemsCount", "showSort"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { Set as ImmutableSet } from 'immutable';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParamInput } from '../../hooks/searchParamHooks';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
// @ts-expect-error Could not find a declaration file for module
import { AccordionSection } from '../../components/Modals/FullScreenModal/AccordionSection';
// @ts-expect-error Could not find a declaration file for module
import { PanelCheckbox } from '../../components/Modals/FullScreenModal/PanelCheckbox';
import { MobileFilterPanel } from '../../components/Modals/FullScreenModal/MobileFilterPanel';
import { PanelSection } from '../../components/Modals/FullScreenModal/PanelSection';
import { getMyPlaylistsUrl } from '../../features/myPlaylists';
import { useCallback } from 'react';
import useNavigate from '../../hooks/useNavigate';
import { isNoResetOptionFilter, isSearchFilter, isSingleOptionFilter, useDefaultFilterValue, useFilterOptions } from '../../features/filters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const filterTypes = Object.values(FILTER_TYPES);
export const FilterGroup = ({
  filterType
}) => {
  const options = useFilterOptions(filterType);
  const [paramValue, changeHandler] = useSearchParamInput(filterType, false);
  const [__, changeHandlerReplace] = useSearchParamInput(filterType, true);
  const value = useDefaultFilterValue(paramValue, filterType);
  const valuesSet = ImmutableSet(value);
  const navigate = useNavigate();
  const onChange = useCallback((item, e) => {
    if (filterType === 'myPlaylistsType') {
      navigate(getMyPlaylistsUrl({
        tab: item
      }));
    } else if (isSingleOptionFilter(filterType)) changeHandlerReplace(e);else changeHandler(e);
  }, [changeHandler, changeHandlerReplace, filterType, navigate]);
  return /*#__PURE__*/_jsxs(AccordionSection, {
    "data-test-id": `filter-type-${filterType}`,
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.topFilters.${filterType}.filterTitle`
    }),
    children: [!isNoResetOptionFilter(filterType) && /*#__PURE__*/_jsx(PanelCheckbox, {
      checked: valuesSet.isEmpty(),
      "data-test-id": `${filterType}-filterReset`,
      onChange: changeHandlerReplace,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.filterReset`
      })
    }, "filterReset"), options.map(item => /*#__PURE__*/_jsx(PanelCheckbox, {
      checked: valuesSet.contains(item),
      "data-test-id": `${filterType}-${item}`,
      onChange: e => onChange(item, e),
      value: item,
      children: filterType === 'language' ? LanguageNames[item.toLowerCase()] : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.${item}`
      })
    }, item))]
  });
};
const MobileTopFilterPanel = _ref => {
  let {
      mobileFilterTypes,
      itemsCount,
      showSort
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(MobileFilterPanel, Object.assign({
    filterTypes: filterTypes,
    totalFilteredItemsCount: itemsCount
  }, restProps, {
    children: /*#__PURE__*/_jsxs(PanelSection, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.mobileFilters.filterBy"
      }),
      children: [filterTypes && mobileFilterTypes.map(value => !isSearchFilter(value) && /*#__PURE__*/_jsx(FilterGroup, {
        filterType: value
      }, value)), showSort && /*#__PURE__*/_jsx(FilterGroup, {
        filterType: 'sortBy'
      })]
    })
  }));
};
export default MobileTopFilterPanel;